"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Strings__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [{
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "length",
    type: "uint256"
  }],
  name: "StringsInsufficientHexLength",
  type: "error"
}];
const _bytecode = "0x60566050600b82828239805160001a6073146043577f4e487b7100000000000000000000000000000000000000000000000000000000600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220337142fb7449c04671cab57339e180bfaa6ef0c7584d7e06d52772e02bfa33eb64736f6c63430008160033";
const isSuperArgs = xs => xs.length > 1;
class Strings__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.Strings__factory = Strings__factory;
_defineProperty(Strings__factory, "bytecode", _bytecode);
_defineProperty(Strings__factory, "abi", _abi);